import React, { useState } from 'react';
import { LuMail, LuLock, LuEye, LuEyeOff, LuShieldAlert } from "react-icons/lu";
import { Link, useNavigate } from 'react-router-dom';
import axios from 'axios';
import Swal from 'sweetalert2';
import { baseurl } from '../../baseurl';
import "../../asset/css/auth.css";

const AdminLogin = () => {
  const [showPassword, setShowPassword] = useState(false);
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleAdminLogin = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      // Sending only email and password
      const response = await axios.post(`${baseurl}loginAdmin`, {
        email,
        password
      });


      console.log("response", response);

      if (response.data.success) {
        localStorage.setItem('adminToken', response.data.token);
        localStorage.setItem('role', 'admin');

        Swal.fire({
          icon: 'success',
          title: 'Access Granted',
          text: 'Welcome to the Admin Dashboard',
          timer: 1500,
          showConfirmButton: false
        });

        setTimeout(() => {
          navigate('/all-users');
        }, 1500);
      }
    } catch (err) {
      Swal.fire({
        icon: 'error',
        title: 'Authentication Failed',
        text: err.response?.data?.message || 'Invalid Admin Credentials',
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-page-wrapper admin-theme">
      <div className="login-card">
        
        <div className="form-section">
          <div className="brand-logo-container">
            <div className="logo-box admin-logo">
              <div className="logo-inner-icon"></div>
            </div>
            <span className="brand-text">Measro <span className="admin-tag">Admin</span></span>
          </div>

          <h1 className="welcome-title">System Login</h1>
          <p className="subtitle">Enter administrative credentials to access the panel</p>

          <form className="login-form" onSubmit={handleAdminLogin}>
            <div className="input-field">
              <label>Administrator Email</label>
              <div className="input-control">
                <LuMail className="icon" />
                <input 
                  type="email" 
                  placeholder="admin@measro.com"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  required 
                />
              </div>
            </div>

            <div className="input-field">
              <label>Secret Password</label>
              <div className="input-control">
                <LuLock className="icon" />
                <input 
                  type={showPassword ? "text" : "password"} 
                  placeholder="••••••••" 
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  required
                />
                <button 
                  type="button" 
                  className="eye-btn"
                  onClick={() => setShowPassword(!showPassword)}
                >
                  {showPassword ? <LuEyeOff /> : <LuEye />}
                </button>
              </div>
            </div>

            <button type="submit" className="login-btn admin-btn" disabled={loading}>
              {loading ? "Authorizing..." : "Access Control Panel"}
            </button>

            <div className="admin-footer">
              <p>Forgot password? Contact system provider.</p>
              <Link to="/login" className="back-link">Standard User Login</Link>
            </div>
          </form>
        </div>

        <div className="info-section admin-sidebar">
          <div className="shield-icon-wrapper">
            <LuShieldAlert />
          </div>
          
          <h2 className="info-title">Admin Terminal</h2>
          <p className="info-description">
            You are attempting to access a restricted administrative area. 
            All actions performed within this terminal are logged and monitored.
          </p>

          <ul className="feature-list">
            <li><span className="check">◈</span> System Configuration</li>
            <li><span className="check">◈</span> User Management</li>
            <li><span className="check">◈</span> Security Audit Logs</li>
            <li><span className="check">◈</span> Database Overrides</li>
          </ul>

          <div className="secure-badge admin-badge">
            Restricted Access Only
          </div>
        </div>

      </div>
    </div>
  );
};

export default AdminLogin;